import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

const PrivacySupportSection = () => {
  const privacyOptions = [
    {
      icon: 'EyeSlashIcon',
      title: 'Privacy Settings',
      description: 'Control your data and visibility',
      action: 'Manage',
    },
    {
      icon: 'ShieldCheckIcon',
      title: 'Security',
      description: 'Two-factor authentication & password',
      action: 'Configure',
    },
    {
      icon: 'DocumentTextIcon',
      title: 'Data Export',
      description: 'Download your account data',
      action: 'Request',
    },
    {
      icon: 'TrashIcon',
      title: 'Delete Account',
      description: 'Permanently remove your account',
      action: 'Delete',
      danger: true,
    },
  ];

  const supportOptions = [
    {
      icon: 'QuestionMarkCircleIcon',
      title: 'Help Center',
      description: 'Browse FAQs and guides',
      link: '#',
    },
    {
      icon: 'ChatBubbleLeftRightIcon',
      title: 'Live Chat',
      description: 'Chat with our support team',
      link: '#',
    },
    {
      icon: 'EnvelopeIcon',
      title: 'Email Support',
      description: 'support@fishbite.com',
      link: 'mailto:support@fishbite.com',
    },
    {
      icon: 'PhoneIcon',
      title: 'Call Us',
      description: '+91 1800-123-4567',
      link: 'tel:+911800123456',
    },
  ];

  return (
    <div className="space-y-6">
      <div className="bg-card rounded-lg border border-border p-6 shadow-elevation-sm">
        <div className="flex items-center gap-3 mb-6">
          <div className="flex items-center justify-center w-10 h-10 bg-secondary/10 rounded-lg">
            <Icon name="LockClosedIcon" size={24} className="text-secondary" />
          </div>
          <div>
            <h2 className="font-heading font-semibold text-lg text-foreground">Privacy & Security</h2>
            <p className="text-sm text-muted-foreground">Manage your account settings</p>
          </div>
        </div>

        <div className="space-y-3">
          {privacyOptions.map((option, index) => (
            <div
              key={index}
              className="flex items-center justify-between gap-4 p-4 rounded-lg bg-background border border-border hover:border-muted-foreground transition-smooth"
            >
              <div className="flex items-center gap-3 flex-1">
                <div className="flex items-center justify-center w-10 h-10 bg-card rounded-md">
                  <Icon
                    name={option.icon as any}
                    size={20}
                    className={option.danger ? 'text-error' : 'text-primary'}
                  />
                </div>
                <div>
                  <h3 className="font-medium text-sm text-foreground mb-1">{option.title}</h3>
                  <p className="text-xs text-muted-foreground">{option.description}</p>
                </div>
              </div>
              <button
                className={`px-4 py-2 rounded-md font-medium text-sm transition-smooth ${
                  option.danger
                    ? 'bg-error/10 text-error hover:bg-error/20' :'bg-muted text-foreground hover:bg-border'
                }`}
              >
                {option.action}
              </button>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-card rounded-lg border border-border p-6 shadow-elevation-sm">
        <div className="flex items-center gap-3 mb-6">
          <div className="flex items-center justify-center w-10 h-10 bg-accent/10 rounded-lg">
            <Icon name="LifebuoyIcon" size={24} className="text-accent" />
          </div>
          <div>
            <h2 className="font-heading font-semibold text-lg text-foreground">Help & Support</h2>
            <p className="text-sm text-muted-foreground">We're here to assist you</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {supportOptions.map((option, index) => (
            <Link
              key={index}
              href={option.link}
              className="flex items-start gap-3 p-4 rounded-lg bg-background border border-border hover:border-primary hover:shadow-elevation-sm transition-smooth"
            >
              <div className="flex items-center justify-center w-10 h-10 bg-card rounded-md">
                <Icon name={option.icon as any} size={20} className="text-primary" />
              </div>
              <div>
                <h3 className="font-medium text-sm text-foreground mb-1">{option.title}</h3>
                <p className="text-xs text-muted-foreground">{option.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacySupportSection;